import { ORDERS_API_URL, SERVER_URL } from "../Consts/config";
import { post } from ".";

const createOrder = async (data) =>
  await post(`${SERVER_URL}${ORDERS_API_URL}`, { ...data });

export { createOrder };
